import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { IS_STUDIO, SITE } from "@/config";
import Home from "@/pages/Home";
import Planning from "@/pages/Planning";
import Reserver from "@/pages/Reserver";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import DevisMariage from "@/pages/DevisMariage";

function App() {
  useEffect(() => {
    document.title = SITE.fullName;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", SITE.footerDesc);
  }, []);

  return (
    <div
      className={`App dark bg-background text-foreground min-h-screen flex flex-col ${
        IS_STUDIO ? "" : "films-gold"
      }`}
    >
      {!IS_STUDIO && (
        <div
          aria-hidden="true"
          className="films-bg-layer"
          style={{ backgroundImage: "url('/bg-films-gold.jpg')" }}
        />
      )}
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/planning" element={<Planning />} />
            <Route path="/reserver" element={<Reserver />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devis-mariage" element={<DevisMariage />} />
            <Route path="/paiement/succes" element={<PaymentSuccess />} />
            <Route path="/paiement/annule" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
